// Use the configured domain without www, matching the existing permanent redirect.
export function siteOrigin(value) {
  if (!value) throw new Error('REACT_APP_SITE_URL required');
  const url = new URL(value);
  url.hostname = url.hostname.replace(/^www\./i, '');
  return url.origin;
}